<template>
  <div class="bg_fff pl15 pr15 pt15 pb15">
    <el-form :model="form" size="mini" label-width="80px">
      <el-row>
        <el-col :span="5">
          <el-form-item label="患者姓名">
            <el-input placeholder="患者姓名" v-model="form.patName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="10px">
            <el-button type="primary" plain @click="sub">查询</el-button>
            <el-button v-if="aspectUser==='init'&&hasEmergencyReferral" @click="apply" type="primary">
              申请转诊
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="申请日期">
            <el-date-picker style="width: 145px"
                            v-model="form.startTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择开始日期">
            </el-date-picker>
            -
            <el-date-picker style="width: 145px"
                            v-model="form.endTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="转诊日期">
            <el-date-picker style="width: 145px"
                            v-model="form.referralStartTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择开始日期">
            </el-date-picker>
            -
            <el-date-picker style="width: 145px"
                            v-model="form.referralEndTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <add-dialog ref="addDialog" @hopeDispatchingCarTypeChange="hopeDispatchingCarTypeChange"></add-dialog>
    <notice-dialog ref="noticeDialog"></notice-dialog>
    <el-dialog :visible.sync="showTag" width="40%" :append-to-body="true">
      <template slot="title"></template>
      <template slot="footer"></template>
      <template slot="default">
        <div style="margin-top: -30px" class="flex">
          <p class="flex0">
            <i class="el-icon-info color_main" style="font-size: 18px"></i>
          </p>
          <p class="flex1" style="margin-left: 5px;">
            线上会诊：请进入互联网医院先进行线上会诊（<a target="_blank"
                                                       class="color_main"
                                                       href="https://www.gjwlyy.com/html/loginRegister/login/login.html#doc">远程会诊登录</a>）；<br/><br/>线下会诊：请联系医务部，传真0571-87074866。
          </p>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import AddDialog from "./add-dialog";
import NoticeDialog from "@/modules/staff/components/notice-dialog";

export default {
  name: "faqi-jieshou-form",
  components: {NoticeDialog, AddDialog},
  props: {
    aspectUser: String,
    hasEmergencyReferral: Boolean
  },
  data() {
    return {
      showTag: false,
      form: {}
    }
  },
  watch: {
    $route() {
      Object.keys(this.form).forEach(key => {
        this.$set(this.form, key, null);
      })
    }
  },
  methods: {
    apply() {
      this.$confirm('请确认该患者是否已会诊并建议转院？', {
        cancelButtonText: '否，请完成会诊后再提交转运申请',
        confirmButtonText: '是，已会诊'
      })
          .then(() => {
            this.$refs.addDialog.show()
          })
          .catch(() => {
            this.showTag = true;
          })
    },
    sub() {
      this.$emit('sub', this.form);
    },
    hopeDispatchingCarTypeChange(val) {
      if (val === 'SUPERIOR_HOSPITAL_HELICOPTER') this.$refs.noticeDialog.show();
    }
  },
}
</script>

<style scoped>

</style>
